import React, { Component } from 'react';
import { $Formutil, connect } from 'react-formutil';
import Toast from 'components/Toast';
import VerifyCodeSend, { VerifyCodeSendProps } from 'components/VerifyCodeSend';

export interface PhoneVerifyFieldType {
    verify_code: string;
}

export interface PhoneVerifyProps extends Pick<VerifyCodeSendProps, 'logined' | 'process'> {
    $formutil: $Formutil<PhoneVerifyFieldType>;
    phoneName?: string;
    telcodeName?: string;
    onSend?: () => void;
}

class PhoneVerify extends Component<PhoneVerifyProps> {
    static defaultProps = {
        phoneName: 'phone',
        telcodeName: 'tel_code'
    };

    onSend = () => {
        if (this.props.onSend) {
            this.props.onSend();
        } else {
            Toast.show(__('发送成功'));
        }
    };

    public render() {
        const { $params, $errors } = this.props.$formutil;
        const hasError = !!$errors[this.props.phoneName!];

        return (
            <div className="phone-verify-root form-group">
                <VerifyCodeSend
                    logined={this.props.logined}
                    process={this.props.process}
                    tel_code={$params[this.props.telcodeName!]}
                    username={hasError ? '' : $params[this.props.phoneName!]}
                    onSend={this.onSend}
                />
            </div>
        );
    }
}

export default connect(PhoneVerify);
